// extracted by mini-css-extract-plugin
export default {"box":"AddTags_box__nTO7e","selectTitle":"AddTags_selectTitle__QrpT+","title":"AddTags_title__H1CbM","inputTitle":"AddTags_inputTitle__vFHW8"};